module.exports = __webpack_public_path__ + "static/media/ConsultantBanner.abfc43e2.svg";